import { QWebChannel } from './qwebchannel';
import axios from 'axios';
import mapi from './mapi';
import { UAParser } from 'ua-parser-js';

var mainWindow = null;
var qtWait = true;

var xlgame = window.xlgame;

function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

class inApp {
    constructor() {

        this.ready = false;
        this.os = "";
        this.bport = 0;

        if (typeof qt != 'undefined') {
            new QWebChannel(qt.webChannelTransport, function (channel) {
                console.log("inApp init channel");
                mainWindow = channel.objects.mainWindow;
                qtWait = false;
            });
            this.os = "pc";
        }

        this.isInApp = false;
    }

    setBport(bport) {
        this.bport = bport;
    }

    setOS(os) {
        this.os = os;
    }

    async init() {
        if (this.ready) {
            return;
        }
        let os = "";
        if (typeof xlgame != 'undefined') {
            os = "android";
        } else if (typeof window.webkit != 'undefined') {
            os = "ios";
        } else if (typeof qt != 'undefined') {
            os = "pc";
        } else if (await this.isMac()) {
            os = "mac";
        }

        this.os = os;
        this.isInApp = this.os != "";

        this.ready = true;
    }


    async has(method) {
        await this.init();
        let os = this.os;
        try {
            switch (os) {
                case "pc":
                    if (qtWait) {
                        await sleep(500);
                        qtWait = false;
                    }

                    if (mainWindow === null || typeof mainWindow[method] == 'undefined') {
                        return false;
                    } else {
                        return true;
                    }
                    break;
                case "android":
                    if (typeof xlgame == 'undefined' || typeof xlgame[method] == 'undefined') {
                        return false;
                    } else {
                        return true;
                    }
                    break;
                case "ios":
                    try {
                        return false;
                    } catch (e) {
                        return true;
                    }

                    break;
            }
        } catch {

        }
        return false;

    }

    waitReady() {
        let me = this;
        return new Promise((resolve, reject) => {
            if (me.ready) {
                resolve();
            } else {
                // 等待 ready 變為 true
                let timer = setInterval(() => {
                    if (me.ready) {
                        clearInterval(timer);
                        resolve();
                    }
                }, 100);
            }
        });
    }
    async callback_mac(method, rr) {
    }

    async callback(method, rr) {
        await this.init();
        // wait for ready
        await this.waitReady();

        let os = this.os;
        try {
            console.log("appcallback: OS is %s", os);
            switch (os) {
                case "pc":
                    if (mainWindow === null) {
                        if (typeof qt == 'undefined') {
                            alert("not in qt browser");
                        } else {
                            new QWebChannel(qt.webChannelTransport, function (channel) {
                                mainWindow = channel.objects.mainWindow;
                                mainWindow[method](JSON.stringify(rr));
                            });
                        }
                    } else {
                        mainWindow[method](JSON.stringify(rr));
                    }
                    break;
                case "android":
                    if (typeof xlgame == 'undefined' || typeof xlgame[method] == 'undefined') {
                        alert("game adapter not ready (  )");
                    } else {
                        xlgame[method](JSON.stringify(rr));
                    }
                    break;
                case "ios":
                    try {
                        window.webkit.messageHandlers[method].postMessage(JSON.stringify(rr));
                    } catch (e) {
                        alert("game adapter not ready ( ios getRecaptchaData )");
                    }

                    break;
                case "mac":
                    this.macCall(method, rr);
                    break;
            }
        } catch {

        }
        return false;
    }


    async isMac() {
        const { os } = UAParser(navigator.userAgent);
        if (os.name == "Mac OS") {
            if (this.macCall("pong", { "a": "b" }) != null) {
                return true;
            } else {
                return true;
            }
        }
    }

    getBport() {
        return urlParams['bport'];
    }
    async macCall(fun, args) {
        const requestData = {
            'function': fun,
            'args': args,
        };
        const requestString = JSON.stringify(requestData);
        const data = 'data=' + requestString;
        try {
            let ret = await axios.post("http://127.0.0.1:" + this.getBport(), data, { headers: { "Content-Type": "text/plain" } });
            if (ret.status == 200) {
                return ret.data;
            } else {
                return null;
            }
        } catch (e) {
            return null;
        }
    }

}

export default inApp;